<app-factor-table
  [title]="'Loss Ratio'" [factors]="factorsData"
  [formatters]="formatters" [modalFilterHeaders]="modalFilterHeaders">
</app-factor-table>